'use strict'

class AbstractService {

}

export default AbstractService
